import { ComponentProps, ReactNode } from 'react';

import { SelectModal } from '@pukka/ui-components';

interface OutletSelectorFooterProps<T>
  extends ComponentProps<Exclude<ComponentProps<typeof SelectModal<T>>['footer'], undefined | ReactNode>> {}

function OutletSelectorFooter<T>({ selections, max, items }: OutletSelectorFooterProps<T>) {
  const limitItems = max < items.size;

  return (
    <div className="text-sm">
      <div className="flex items-center">
        <span>{`Selected Outlet${limitItems ? ` (Max. ${max})` : ''}: ${selections.size}`}</span>
      </div>
      {selections.size === 0 && (
        <div>
          <small className="text-red-500">Please select at least one item.</small>
        </div>
      )}
    </div>
  );
}

export { OutletSelectorFooter };
